/* eslint-disable eqeqeq */
import { EyeOutlined } from '@ant-design/icons';
import { Button, Tooltip } from 'antd';
import axios from 'axios';
import { useContext } from 'react';
import getReturnInvoiceApi from '../../../apis/return-invoice-apis/getReturnInvoiceApi';
import EditIcon from '../../../common/icons/EditIcon';
import UserContext from '../../../contexts/user-context/UserProvider';
import useCustomApiRequest from '../../../custom-hooks/useCustomApiRequest';
import errorNotification from '../../../utils/errorNotification';

const TableColumns = (
  allFetchedReceipts,
  setModalOpened,
  setFetchCount,
  setSelectedReceipt,
  setIsLoading,
  setSelectedReceiptModalOpened,
  setInstallmentModalOpened,
  withoutReturnBtn,
  token,
  taxPage,
  t,
  subscriptionType
) => {

  const arr =
    allFetchedReceipts?.invoices?.length > 0
      ? allFetchedReceipts.invoices
      : allFetchedReceipts;
  const { user } = useContext(UserContext);
  const customApiRequest = useCustomApiRequest();
  const handleViewReceiptClick = (record) => {
    if (taxPage) {
      setSelectedReceipt(record);
      setSelectedReceiptModalOpened(true);
    }

    const foundReceipt =
      arr?.length > 0 && arr.find((receipt) => receipt.id === record.id);

    if (foundReceipt) {
      setSelectedReceipt({ ...foundReceipt });
      setSelectedReceiptModalOpened(true);
    }
  };

  const handleReturnClick = (record) => {
    let id = record?.parentInvoice != 0 && record?.parentInvoice != undefined ? record?.parentInvoice : record.id
    customApiRequest(
      getReturnInvoiceApi(user?.token, id ),
      (res) => {
        setIsLoading(false);
        if (res?.data?.data) {
          setModalOpened(true);
          setSelectedReceipt(res?.data?.data)
          // setFetchCount((prevState) => prevState + 1);

        } else {
          errorNotification({
            title: t('Invoices.errorOccurred'),
            message: res?.data?.message
              ? res.data.message
              : t('Invoices.tryLaterMessage')
          });
        }
      },
      (error) => {
        setIsLoading(false);
      }
    );
    // const foundReceipt =
    //   arr?.length > 0 && arr.find((receipt) => receipt.id === record.id);
    // if (foundReceipt) {
    //   setSelectedReceipt({ ...foundReceipt });
    //   setModalOpened(true);
    // }
  };

  const renderActions = (record) => {
    if (record?.is_return === 0) {
      if (parseFloat(record?.totalPrice) == 0) {
        return (
          <div
            className="edit-btn"
            style={{
              opacity: '.6',
              cursor: 'not-allowed'
            }}
          >
            <EditIcon />
            {t('purchaseInvoices.returnRequest')}
          </div>
        );
      }
      return (
        <div className="edit-btn" onClick={() => handleReturnClick(record)}>
          <EditIcon />
          {t('purchaseInvoices.returnRequest')}
        </div>
      );
    } else if (record?.is_return === 1) {
      return (
        <div
          className="edit-btn"
          style={{
            opacity: '.6',
            cursor: 'not-allowed'
          }}
        >
          {t('Invoices.invoiceReturned')}
        </div>
      );
    } else if (record?.is_return === 2) {
      return (
        <div className="edit-btn" onClick={() => handleReturnClick(record)}>
          <EditIcon />
          {t('Invoices.ReturnRequest')}
        </div>
      );
    } else {
      return t('purchaseInvoices.invoiceReturned');
    }
  };
  // ${
  //   subscriptionType == 1
  //     ? `/BuyInvoice/share`
  //     : subscriptionType == 2
  //     ? `saleInvoice/share`
  //     : ``
  // }

  const handleShareApi = async (invoiceId) => {
    try {
      const res = await axios
        .get(`/BuyInvoice/share?invoice_id=${invoiceId}`, {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token,
            lang: 'ar'
          }
        })
        .then((res) => {
          if (res?.data?.data?.url) {
            window.location.href = res?.data?.data?.url;
          }
        })
        .catch((err) => {

        });

      return res;
    } catch (error) {
      throw error;
    }
  };
  const handleShareEmailApi = async (invoiceId) => {
    try {
      const res = await axios
        .post(
          `/BuyInvoice/email?invoice_id=${invoiceId}`,
          {},
          {
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + token,
              lang: 'ar'
            }
          }
        )
        .then((res) => {
          if (res?.data?.data?.url) {
            window.location.href = res?.data?.data?.url;
          }
        })
        .catch((err) => {

        });

      return res;
    } catch (error) {
      throw error;
    }
  };

  const renderShareBtn = (invoiceId) => {
    return (
      <div className="row-cell row-circled-btn">
        <div
          className="bt-target"
          onClick={() => {
            handleShareApi(invoiceId);
          }}
          style={{
            color: 'white',
            fontSize: '15px'
          }}
        >
          مشاركة{' '}
        </div>
      </div>
    );
  };

  const renderShareEmailBtn = (invoiceId) => {
    return (
      <div className="row-cell row-circled-btn">
        <div
          className="bt-target"
          onClick={() => {
            handleShareEmailApi(invoiceId);
          }}
          style={{
            color: 'white',
            fontSize: '15px'
          }}
        >
          {t('purchaseInvoices.sendEmail')}
        </div>
      </div>
    );
  };

  return [
    {
      title: t('purchaseInvoices.serialNumber'),
      dataIndex: 'id',
      // width: 62
      render: (_, record) => {
        return (
          <div className="row-cell row-index bold-font">
            <span>{record.invoiceNumber}</span>
          </div>
        );
      }
    },
    {
      title: t('purchaseInvoices.invoiceNumber'),
      dataIndex: 'manualNum',
      render: (_, record) => {
        return (
          <div className="row-cell row-text">
            {record?.manualNum ? record.manualNum : '--'}
          </div>
        );
      }
    },
    {
      title: t('purchaseInvoices.supplier'),
      dataIndex: 'user',
      render: (_, record) => {
        return (
          <div className="row-cell row-text desc-wrap">
            {record?.supplier?.name ? record.supplier.name : '----'}
          </div>
        );
      }
    },

    {
      title: t('purchaseInvoices.invoiveDate'),
      dataIndex: 'date',
      render: (_, record) => {
        return (
          <div className="row-cell row-text">
            {record?.date ? record.date : '----'}
          </div>
        );
      }
    },
    {
      title: t('purchaseInvoices.dueDate'),
      dataIndex: 'dueDate',
      render: (_, record) => {
        return (
          <div className="row-cell row-text">
            {record?.dueDate ? record.dueDate : '----'}
          </div>
        );
      }
    },
    {
      title: t('purchaseInvoices.time'),
      dataIndex: 'time',
      render: (_, record) => {
        return (
          <div className="row-cell row-text">
            {record?.time ? record.time : '----'}
          </div>
        );
      }
    },
    // {
    //   title: 'ملاحظات',
    //   dataIndex: 'note',
    //   render: (_, record) => {
    //     if (record.note) {
    //       const wordsCount = countWords(String(record.note));
    //       if (wordsCount > 3) {
    //         return (
    //           <Popover title="اقرأ المزيد" content={String(record.note)}>
    //             <Button size="large" type="text">
    //               <p className="has-read-more">
    //                 <span>{trimWords(String(record.note), 4)}</span>
    //                 <ReadOutlined
    //                   className="read-more-book"
    //                   style={{ margin: '0 4px' }}
    //                 />
    //               </p>
    //             </Button>
    //           </Popover>
    //         );
    //       } else
    //         return (
    //           <div className="row-cell row-text">{String(record.note)}</div>
    //         );
    //     } else {
    //       return '----';
    //     }
    //   }
    // },

    {
      title: t('purchaseInvoices.totalPrice'),
      dataIndex: 'totalPrice',
      render: (_, record) => {

        return (
          <div className="row-cell row-text">
          {record?.type==2&&record?.totalPrice>0&&" - "}
            {record?.totalPrice ? record.totalPrice : '----'}
          </div>
        );
      }
    },
    // {
    //   title: 'إيصالات الفاتورة',
    //   render: (_, record) => {
    //     return record?.paymentType === 2 ? (
    //       <RouterLink
    //         className="row-cell row-circled-btn"
    //         to={routerLinks.installmentsPage(record.id)}
    //       >
    //         <Tooltip title="إيصالات الفاتورة">
    //           <Button
    //             className="circled-btn"
    //             type="dashed"
    //             shape="circle"
    //             icon={<EyeOutlined />}
    //           />
    //         </Tooltip>
    //       </RouterLink>
    //     ) : (
    //       '----'
    //     );
    //   }
    // },
    // {
    //   title: 'إرسال إيميل',
    //   width: 135,
    //   dataIndex: 'totalPrice',
    //   render: (_, record) => {
    //     return (
    //       <div className="row-cell row-text">
    //         {renderShareEmailBtn(record?.id)}
    //       </div>
    //     );
    //   }
    // },
    // {
    //   title: 'مشاركة الفاتورة',
    //   dataIndex: 'totalPrice',
    //   render: (_, record) => {
    //     return (
    //       <div className="row-cell row-text">{renderShareBtn(record?.id)}</div>
    //     );
    //   }
    // },
    {
      title: t('purchaseInvoices.invoicePreview'),
      render: (_, record) => {
        return (
          <div className="row-cell row-circled-btn">
            <Tooltip title={t('purchaseInvoices.invoicePreview')}>
              <Button
                className="circled-btn"
                type="dashed"
                shape="circle"
                icon={<EyeOutlined />}
                onClick={() => handleViewReceiptClick(record)}
              />
            </Tooltip>
          </div>
        );
      }
    },
    withoutReturnBtn
      ? {}
      : {
          title: t('purchaseInvoices.returnRequest'),
          dataIndex: 'totalPrice',
          render: (_, record) => {
            return (
              <div className="row-cell row-actions">
                {record?.type == 2 && (record?.parentInvoice != 0 && record?.parentInvoice != undefined) ? (
                  <div className="row-cell row-actions">
                    <h3>{t('purchaseInvoices.returnedInvoice')}</h3>
                  </div>
                ) : record?.type == 1 && (record?.parentInvoice == 0 || record?.parentInvoice == undefined) ? (
                  <div className="row-cell row-actions">
                    {renderActions(record)}
                  </div>
                ) : null}
              </div>
            );
          }
        }
  ];
};

export default TableColumns;


